import _classCallCheck from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/createClass";
import * as Digest from './digest.js';
export var from = function from(_ref) {
  var name = _ref.name,
      code = _ref.code,
      encode = _ref.encode;
  return new Hasher(name, code, encode);
};
export var Hasher = /*#__PURE__*/function () {
  function Hasher(name, code, encode) {
    _classCallCheck(this, Hasher);

    this.name = name;
    this.code = code;
    this.encode = encode;
  }

  _createClass(Hasher, [{
    key: "digest",
    value: function digest(input) {
      var _this = this;

      if (input instanceof Uint8Array) {
        var result = this.encode(input);
        return result instanceof Uint8Array ? Digest.create(this.code, result) : result.then(function (digest) {
          return Digest.create(_this.code, digest);
        });
      } else {
        throw Error('Unknown type, must be binary type');
      }
    }
  }]);

  return Hasher;
}();